import React from 'react';

const ComponentStylesContext = React.createContext({});

// componentStyles is an object, keys are component names, values are functions that return styles
// the functions are passed the theme as its only argument
export const ComponentStylesProvider = ({ children, componentStyles }) => (
  <ComponentStylesContext.Provider value={componentStyles}>
    {children}
  </ComponentStylesContext.Provider>
);

// get the getStyles function for a component by name
// returns null if the component has no styles
export const useComponentStylesContext = (componentName) => {
  const componentStyles = React.useContext(ComponentStylesContext);
  if (componentStyles && componentStyles[componentName]) {
    return componentStyles[componentName];
  }
  return null;
};
